import * as Yup from "yup";

const sValidationNumberOnly = "basicValidation.numbersOnly";
const sValidationTooShort = "basicValidation.tooShort";
export const sValidationMissingField = "basicValidation.missingFields";
const sValidationTooLong = "basicValidation.tooLong";
const hasInvalidChars = (value) => /[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(value);
const startsWithDot = (value) => value.charAt(0) === ".";
const countryRules = {
  "+60": { min: 9, max: 10 },
  "+65": { min: 7, max: 10 },
  "+91": { min: 10, max: 10 },
  default: { min: 10, max: 16, specificStart: "628" },
};

export const phoneValidationSchema = Yup.string()
  .required(sValidationMissingField)
  .test("invalid-characters", sValidationNumberOnly, (val) => {
    return !hasInvalidChars(val) && !startsWithDot(val);
  })
  .test("length-check", function validateLength(val) {
    const { countryCode } = this.parent; // Assuming countryCode is part of the form values
    const rules = countryRules[countryCode] || countryRules["default"];

    if (val.length > rules.max) return sValidationTooLong;
    if (val.length < rules.min) return sValidationTooShort;

    return true;
  })
  .test("specific-start-check", "basicValidation.properFormat", function validateStart(val) {
    const { countryCode } = this.parent;
    const rules = countryRules[countryCode] || countryRules["default"];
    return !rules.specificStart || val.startsWith(rules.specificStart);
  });

export const validationCheck = {
  otp: (val) => {
    if (/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(val)) {
      return sValidationNumberOnly;
    }
    if (val > 0 && val.length < 4) {
      return sValidationTooShort;
    }
    return "";
  },
  phone: (val, countryCode) => {
    if (val === "") return sValidationMissingField;

    const rules = countryRules[countryCode] || countryRules["default"];

    if (hasInvalidChars(val) || startsWithDot(val)) return sValidationNumberOnly;
    if (val.length > rules.max) return sValidationTooLong;
    if (val.length < rules.min) return sValidationTooShort;
    if (rules.specificStart && !val.startsWith(rules.specificStart)) return "basicValidation.properFormat";

    return "";
  },
};

export const validate = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .required(t(sValidationMissingField))
      .transform((originalValue) => {
        return originalValue ? originalValue.trim() : originalValue;
      }),
    employeeId: Yup.string().required(t(sValidationMissingField)).matches(/^\S*$/, t("basicValidation.noSpaces")),
    bankNumber: Yup.string()
      .required(t(sValidationMissingField))
      .test({
        name: "numbersOnly",
        test: (val) => {
          const trimmedValue = val.trim();
          return !/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(trimmedValue);
        },
        message: sValidationNumberOnly,
      })
      .transform((originalValue) => {
        return originalValue.trim();
      }),
    beneficiaryName: Yup.string().required(t(sValidationMissingField)),
    // .matches(/^[^!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,0-9\`\[\]\{\}]*$/, t("basicValidation.lettersOnly")),
  });
